module.exports = __webpack_public_path__ + "static/img/cabinet24_12.1bf827eb.gif";